<mat-form-field>
  <mat-select
    [placeholder]="placeholder"
    [formControl]="effectiveControl"
    [panelClass]="panelClass || ''"
    (selectionChange)="onSelectionChange($event.value)"
  >
    @for (option of options; track $index) {
      <mat-option [value]="option">
        @if (optionTemplate) {
          <ng-container
            [ngTemplateOutlet]="optionTemplate"
            [ngTemplateOutletContext]="{ $implicit: option }"
          ></ng-container>
        } @else {
          {{ displayFn(option) }}
        }
      </mat-option>
    }
  </mat-select>
  @if (suffixIcon) {
    <mat-icon matSuffix>{{ suffixIcon }}</mat-icon>
  }
</mat-form-field>
